__turbopack_context__.v({
  "incompatible-cart-layer": "incompatible-cart-layer-component-module-scss-module__EIjQ7a__incompatible-cart-layer",
  "incompatible-cart-layer__buttons": "incompatible-cart-layer-component-module-scss-module__EIjQ7a__incompatible-cart-layer__buttons",
  "incompatible-cart-layer__text": "incompatible-cart-layer-component-module-scss-module__EIjQ7a__incompatible-cart-layer__text",
  "incompatible-cart-layer__title": "incompatible-cart-layer-component-module-scss-module__EIjQ7a__incompatible-cart-layer__title",
});
